import script from "./AnnouncementsComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnnouncementsComponent.vue?vue&type=script&setup=true&lang=ts"

import "./AnnouncementsComponent.vue?vue&type=style&index=0&id=2ad5d282&lang=css"

const __exports__ = script;

export default __exports__